import { BookingTag } from "../types/VenueGroup";
import { CustomFieldTag, BookingV4 } from "../types/bookings";

export const filterCompletedCustomFields = (
  tags: CustomFieldTag[],
  config: BookingTag[]
): CustomFieldTag[] => {
  return tags.filter((tag) => {
    const fieldConfig = config.find(
      (c) => c.id === (tag as any).id || (c as any).name === (tag as any).name
    );

    if (!fieldConfig) {
      return false;
    }

    const fieldType = fieldConfig.type || (tag as any).text || tag.type;

    if (fieldType === "boolean") {
      return tag.value !== null && tag.value !== undefined;
    }

    if (fieldType === "text") {
      return tag.value && tag.value.toString().trim() !== "";
    }

    if (fieldType === "select" || fieldType === "multiselect") {
      return (
        tag.value &&
        (Array.isArray(tag.value)
          ? tag.value.length > 0
          : tag.value.toString().trim() !== "")
      );
    }

    return (
      tag.value !== null &&
      tag.value !== undefined &&
      tag.value.toString().trim() !== ""
    );
  });
};

export interface CustomFieldsValidationData {
  selectedBooking: BookingV4;
  venueConfig: any;
  venueGroupConfig: any;
  customFieldsConfig: any[];
  completedFields: CustomFieldTag[];
}

export const validateCustomFieldsData = (
  selectedBooking: BookingV4 | undefined,
  venueConfig: any,
  venueGroupConfig: any
): CustomFieldsValidationData | null => {
  if (!selectedBooking || !venueConfig || !venueGroupConfig) {
    return null;
  }

  const customFieldsConfig = venueGroupConfig.booking_tags || [];
  if (!customFieldsConfig || customFieldsConfig.length === 0) {
    return null;
  }

  const completedFields = filterCompletedCustomFields(
    selectedBooking.tags || [],
    customFieldsConfig
  );

  if (!completedFields || completedFields.length === 0) {
    return null;
  }

  return {
    selectedBooking,
    venueConfig,
    venueGroupConfig,
    customFieldsConfig,
    completedFields
  };
};

export const formatFieldValue = (field: CustomFieldTag): string => {
  if (field.value === null || field.value === undefined) {
    return "";
  }

  if (Array.isArray(field.value)) {
    return field.value.join(", ");
  }

  if (typeof field.value === "boolean") {
    return field.value ? "Yes" : "No";
  }

  return field.value.toString();
};
